export const categories = [
  {
    id: 'celebrity',
    name: '明星八卦',
    slug: 'celebrity',
    description: '追踪娱乐圈最新动态，爆料明星私生活、恋情绯闻、出轨离婚等劲爆内容',
    icon: 'ri-star-line',
    articleCount: 128,
  },
  {
    id: 'influencer',
    name: '网红黑料',
    slug: 'influencer',
    description: '揭秘网红圈不为人知的秘密，曝光翻车现场、带货翻车、人设崩塌等猛料',
    icon: 'ri-fire-line',
    articleCount: 96,
  },
  {
    id: 'daily',
    name: '每日大赛',
    slug: 'daily',
    description: '每天精选最劲爆的吃瓜事件进行PK大赛，投票选出当日最震撼的瓜',
    icon: 'ri-trophy-line',
    articleCount: 64,
  },
  {
    id: 'social',
    name: '社会热点',
    slug: 'social',
    description: '聚焦社会热门事件，深度剖析热点话题背后的真相与细节',
    icon: 'ri-global-line',
    articleCount: 85,
  },
];